import React, { useState, useEffect } from "react";
import {
  TextField,
  CircularProgress,
  Autocomplete,
  Snackbar,
} from "@mui/material";
import { getProveedores } from "../service/apiProveedores";
import CrearProveedor from "../crudComponents/createProveedor";

const ProveedoresSelect = ({
  onProveedorChange,
  valorIdCliente,
  nifCliente,
  numTarjeta,
  numCuenta,
  matricula,
  direccion,
}) => {
  const [proveedores, setProveedores] = useState([]); // Lista de proveedores
  const [filteredProveedores, setFilteredProveedores] = useState([]); // Lista filtrada
  const [selectedProveedor, setSelectedProveedor] = useState(null); // Proveedor seleccionado
  const [loading, setLoading] = useState(false); // Estado de carga
  const [searchQuery, setSearchQuery] = useState(""); // Para el campo de búsqueda
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [openDialogProv, setOpenDialogProv] = useState(false);

  const handleOpenDialog = () => {
    setOpenDialogProv(!openDialogProv);
  };
  //Funcion para eliminar tildes en la busqueda de proveedores
  const normalizarTexto = (texto) => {
    return texto
      ?.normalize("NFD") // Separar tildes
      .replace(/[\u0300-\u036f]/g, "") // Eliminar tildes
      .toLowerCase() // Minúsculas
      .replace(/v/g, "b"); // Reemplazar 'v' por 'b'
  };
  // Función para obtener proveedores del backend
  const fetchProveedores = async () => {
    try {
      setLoading(true);
      const response = await getProveedores();
      setProveedores(response);
      setFilteredProveedores(response); // Inicialmente, mostrar todos los proveedores
      setLoading(false);
    } catch (error) {
      console.error("Error al obtener los proveedores:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchProveedores();
  }, []);

  useEffect(() => {
    const searchTrimmed = normalizarTexto(searchQuery.trim()); // Normalizamos la búsqueda en minúsculas
    const result = proveedores.filter((proveedor) => {
      const nifProveedor = normalizarTexto(
        proveedor.prov_nif?.toString() || "",
      );
      const nombreProveedor = normalizarTexto(proveedor.prov_nombre || ""); // Nombre en minúsculas

      // Verificar si la búsqueda está en el NIF o en el nombre
      const coincideNif = nifProveedor.includes(searchTrimmed);
      const coincideNombre = nombreProveedor.includes(searchTrimmed);

      // Retornar verdadero si coincide en nombre o en NIF
      return coincideNif || coincideNombre;
    });

    setFilteredProveedores(result); // Actualizar los proveedores filtrados
  }, [searchQuery, proveedores]);

  // Maneja la selección de un proveedor
  const handleProveedorChange = (event, newValue) => {
   //console.log(newValue);
    setSelectedProveedor(newValue);
    if (typeof onProveedorChange === "function") {
      if (newValue) {
        const nombreProveedor = newValue.prov_nombre;
        onProveedorChange(nombreProveedor);
        valorIdCliente(newValue.prov_id);
        nifCliente(newValue.prov_nif);
        numTarjeta(newValue.prov_num_tarjeta_ecopay);
        numCuenta(newValue.prov_cta_bancaria);
        matricula(newValue.prov_matricula);
        direccion(
          `${newValue.prov_direccion} -${newValue.prov_poblacion}, ${newValue.prov_provincia}`,
        );
      } else {
        valorIdCliente("");
        matricula("");
        onProveedorChange("");
      }
    }
  };

  // Maneja los cambios en el input de búsqueda
  const handleSearchQueryChange = (event, newInputValue) => {
    setSearchQuery(newInputValue);
    // Filtra proveedores según el texto ingresado
    setFilteredProveedores(
      proveedores.filter((proveedor) => {
        const nombreProveedor = proveedor.prov_nombre
          ? proveedor.prov_nombre.toLowerCase()
          : ""; // Evita el error si es null

        const nifProveedor = proveedor.prov_nif
          ? proveedor.prov_nif.toString().toLowerCase()
          : ""; // Asegura que siempre sea string

        return (
          normalizarTexto(nombreProveedor).includes(
            normalizarTexto(newInputValue),
          ) ||
          normalizarTexto(nifProveedor).includes(normalizarTexto(newInputValue))
        );
      }),
    );
  };

  return (
    <div>
      {loading ? (
        <CircularProgress />
      ) : (
        <Autocomplete
          size="small"
          options={filteredProveedores}
          getOptionLabel={(option) =>
            typeof option === "string"
              ? option
              : `${option.prov_nombre} - ${option.prov_nif}`
          }
          filterOptions={(options, state) => {
            const filtered = options.filter((option) =>
              normalizarTexto(
                `${option.prov_nombre} - ${option.prov_nif}`,
              ).includes(normalizarTexto(state.inputValue)),
            );

            if (state.inputValue !== "") {
              filtered.push({
                prov_id: "",
                prov_nombre: `Crear proveedor "${state.inputValue}"`,
                prov_nif: "",
                isNew: true,
              });
            }

            return filtered;
          }}
          value={selectedProveedor}
          onChange={(event, newValue) => {
            if (newValue && newValue.isNew) {
              handleOpenDialog();
            } else {
              handleProveedorChange(event, newValue);
            }
          }}
          inputValue={searchQuery}
          onInputChange={handleSearchQueryChange}
          noOptionsText="No se encontraron proveedores"
          renderOption={(props, option) => (
            <li {...props} key={option.prov_id}>
              {option.prov_nombre}
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Selecciona un proveedor"
              variant="outlined"
              fullWidth
            />
          )}
        />
      )}

      {/* Este sí se renderiza */}
      {openDialogProv && (
        <CrearProveedor
          openDialog={openDialogProv}
          onClose={handleOpenDialog}
          setSnackbarMessage={setSnackbarMessage}
          setOpenSnackbar={setShowSnackbar}
          setProveedores={setProveedores}
        />
      )}
      <Snackbar
        open={showSnackbar}
        autoHideDuration={6000}
        onClose={() => setShowSnackbar(false)}
        message={snackbarMessage}
      />
    </div>
  );
};

export { ProveedoresSelect };
